import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '../../../../components/Sidebar/Sidebar';
import {
  ButtonCollapseStyled,
  ContentWrapStyled,
  LayoutStyled,
  SidebarWrapStyled,
} from './TicketsPageLayout.styled';
import { useTickets } from 'contexts/TicketsContext';
import { DoubleArrowUpIcon } from 'icons';
import DealerReport from 'pages/TicketsPage/components/DealerReport/DealerReport';
import Header from 'pages/TicketsPage/components/Header/Header';

const TicketsPageLayout: FC = () => {
  /**
   * Hooks
   */
  const { setSidebarIsOpen, isSidebarOpened } = useTickets();

  /**
   * Handlers
   */
  const handleViewSidebar = () => {
    setSidebarIsOpen(!isSidebarOpened);
  };

  return (
    <LayoutStyled>
      <SidebarWrapStyled isOpened={isSidebarOpened}>
        <Sidebar isSidebarOpened={isSidebarOpened} />
        <ButtonCollapseStyled
          size="xs"
          variant="outline"
          className="collapse-sidebar-btn"
          onClick={handleViewSidebar}
          isOpened={isSidebarOpened}
          icon={<DoubleArrowUpIcon />}
          title={isSidebarOpened ? 'Hide sidebar' : 'Show sidebar'}
        >
          Collapse
        </ButtonCollapseStyled>
      </SidebarWrapStyled>
      <ContentWrapStyled isOpened={isSidebarOpened}>
        <DealerReport />
        <Header />
        <Outlet />
      </ContentWrapStyled>
    </LayoutStyled>
  );
};

export default TicketsPageLayout;
